<div class="container">
  <div class="warn-validation"
    *ngIf="!(this.isValidate || this.isCommerce)">
    <span>Su usuario no se encuentra validado, por favor para
      validarlo y poder operar con normalidad ingrese a la
      aplicación movil, complete la validación de identidad y prueba
      de vida.</span>
  </div>
  <h1 class="name-h1">{{ nombre }}</h1>
  <section class="balance-section">
    <div matRipple #filterAvailables class="balance-box general"
      *ngIf="!isResponsible">
      <div class="bb-content">
        <div class="text-button">
          <span class="bb-subtitulo">
            {{ 'pages.account_yacare.balance' | translate }}
          </span>
          <div style="display: flex;">
            <button mat-icon-button class="button-eye"
              (click)="hideBalances()">
              <mat-icon style="color:#FF6600">{{ isVisible ?
                'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <button class="button-eye" mat-icon-button
              appThrottled="click" appThrottledDirective
              appThrottledDuration="10000"
              (appThrottledEvent)="handleClick()">
              <mat-icon class="refresh-active">refresh</mat-icon>
            </button>
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <amount-component class="amount-component"
            [isHide]="isVisible"
            [value]="balances.availableBalance"></amount-component>
        </div>
        <div></div>
      </div>
    </div>
    <div class="balance-box" *ngIf="!isResponsible">
      <div class="to-collect">
        <div class="bb-content">
          <div class="balance-box-cont">
            <div class="to-collect-container">
              <a (click)="goToMovements()"
                matTooltip="Ir a movimientos por cobrar"
                class="bb-subtitulo saldo-link"> {{
                'pages.account_yacare.balance_to_collect' |
                translate }} </a>
                <a (click)="goToSchedule()"class="calendar-link"  matTooltip="Ir a agenda de flujos futuros">
                  <span>Flujos futuros</span>                  
                  <mat-icon class="calendar-icon"
                  >calendar_today</mat-icon> </a>
              
            </div>
            <amount-component [isHide]="isVisible"
              [value]="balances.toCollectBalance"></amount-component>
          </div>
        </div>
      </div>
      <hr />
      <div class="general">
        <div class="bb-content">
          <div class="balance-box-cont">
            <span class="bb-subtitulo"> {{
              'pages.account_yacare.general_balance' | translate
              }}</span>
            <amount-component class="general-balance"
              [isHide]="isVisible"
              [value]="balances.generalBalance"></amount-component>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <div class="container-general">
    <div class="content-section">
    </div>
  </div> -->
</div>
